var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 15,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M21.233 0H1.767C.793 0 0 .814 0 1.814v11.372C0 14.186.793 15 1.767 15h19.466c.974 0 1.767-.814 1.767-1.814V1.814C23 .814 22.207 0 21.233 0Zm-.519 1.13-8.83 6.401a.653.653 0 0 1-.768 0L2.285 1.13h18.43ZM1.1 1.815c0-.052.005-.102.016-.15L7.248 6.11 1.1 9.954v-8.14Zm20.8 11.37c0 .378-.3.686-.667.686H1.766a.677.677 0 0 1-.666-.685v-1.91L8.228 6.82l2.254 1.634a1.732 1.732 0 0 0 2.035 0l2.255-1.634 7.128 4.456v1.91Zm0-3.231L15.75 6.11l6.132-4.446c.011.049.017.099.017.15v8.14Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.8bfaaa0711872d3e12738a99e02cc02e.svg";
export { ForwardRef as ReactComponent };